import { and } from 'airbnb-prop-types';
import { arrayOf, array, bool, func, number, oneOfType, shape, string } from 'prop-types';
/**
 * Custom prop type validator that checks string length.
 */

var maxLineLength = function maxLineLength(props, propName) {
  var componentName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ANONYMOUS';

  // eslint-disable-next-line no-underscore-dangle
  if (props.__dangerouslyAllowLongLabel) {
    return null;
  }

  if (props[propName]) {
    var value = props[propName];
    /* 21 characters is the max number of characters
     * for iPhone 5's select element */

    var maxChars = 21;

    if (typeof value === 'string') {
      return value.length <= maxChars ? null : new Error("Keep ".concat(propName, " in ").concat(componentName, " under ").concat(maxChars, " characters. Line length on ").concat(propName, " is ").concat(value.length - maxChars, " characters too long."));
    }
  }

  return null;
};

export var SELECT_PROP_TYPES = {
  id: string.isRequired,
  name: string.isRequired,
  fullWidth: bool,
  block: bool,
  className: string,
  disabled: bool,
  error: bool,
  multiple: bool,
  onFocus: func,
  onBlur: func,
  popover: bool,
  searchable: bool,
  unselected: oneOfType([// true = blank label
  bool, // custom label
  string])
};
export var SELECT_DEFAULT_PROPS = {
  id: '',
  name: '',
  multiple: false,
  unselected: null
};
export var OPTION_PROP_TYPES = {
  label: and([maxLineLength, string]),
  value: oneOfType([string, number, array, bool]),
  disabled: bool,
  __dangerouslyAllowLongLabel: bool
};
export var OPTGROUP_PROP_TYPES = {
  title: and([maxLineLength, string]),
  options: arrayOf(shape(OPTION_PROP_TYPES))
};